// extracted by mini-css-extract-plugin
module.exports = {"container":"Header-module_container_1xQ6P","image":"Header-module_image_5NmUs","spacing":"Header-module_spacing_IcnTJ"};